import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faAddressBook,
  faCog,
  faUser,
  faPlusSquare,
  faList,
  faCartPlus,
  faTachometerAlt,
  faCalendarCheck,
 faUserDoctor,
 faHospitalUser,
 faShieldHalved,
 faHandshake,
 faPhone,
 faCircleInfo,
 faCalendarPlus,
 faMoneyBillWave
} from '@fortawesome/free-solid-svg-icons'
import { CNavGroup, CNavItem } from '@coreui/react'

const _nav = [
  {
    component: CNavItem,
    name: 'MENU',
    to: '/dashboard',
    disabled: true,
  },

  {
    component: CNavItem,
    name: 'Dashboard',
    to: '/dashboard',
    icon: <FontAwesomeIcon icon={faTachometerAlt} className="nav-icon" />,
  },
  {
    component: CNavGroup,
    name: 'User Mgmt',
    icon: <FontAwesomeIcon icon={faUser} className="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Create New User',
        icon: <FontAwesomeIcon icon={faAddressBook} className="nav-icon" />,
        to: '/AddNewUser',
      },
      {
        component: CNavItem,
        name: 'Users Listing',
        icon: <FontAwesomeIcon icon={faList} className="nav-icon" />,
        to: '/UserList',
      },
    ],
  },

  {
    component: CNavGroup,
    name: 'Doctor Info Mgmt',
    icon: <FontAwesomeIcon icon={faUserDoctor} className='nav-icon' />,
    items: [
      {
        component: CNavItem,
        name: 'List of Doctor Info',
        icon: <FontAwesomeIcon icon={faList} className="nav-icon" />,
        to: '/doctorList',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Patient Info Mgmt',
    icon: <FontAwesomeIcon icon={faHospitalUser} className="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'List of Patient Info',
        icon: <FontAwesomeIcon icon={faList} className="nav-icon" />,
        to: '/patientList',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Specialities Mgmt',
    icon: <FontAwesomeIcon icon={faCartPlus} className="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Add New',
        icon: <FontAwesomeIcon icon={faPlusSquare} className="nav-icon" />,
        to: '/AddNewSpecialities',
      },
      {
        component: CNavItem,
        name: 'Specialities List',
        icon: <FontAwesomeIcon icon={faList} className="nav-icon" />,
        to: '/SpecialityList',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Appointment Mgmt',
    icon: <FontAwesomeIcon icon={faCalendarCheck} className='nav-icon' />,
    items: [
      {
        component: CNavItem,
        name: 'Appointment List',
        icon: <FontAwesomeIcon icon={faList} className="nav-icon" />,
        to: '/AppointmentList',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Transaction Mgmt',
    icon: <FontAwesomeIcon icon={faMoneyBillWave} className="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Transaction List',
        icon: <FontAwesomeIcon icon={faList} className="nav-icon" />,
        to: '/dashboard',
      }
    ],
  },
  {
    component: CNavGroup,
    name: 'Content Mgmt',
    icon: <FontAwesomeIcon icon={faCircleInfo}   className="nav-icon"/>,
    items: [
      {
        component: CNavItem,
        name: 'About Us',
        icon: <FontAwesomeIcon icon={faList} className="nav-icon" />,
        to: '/dashboard',
      },
      {
        component: CNavItem,
        name: 'Contact Us',
        icon: <FontAwesomeIcon icon={faPhone} className="nav-icon" />,
        to: '/dashboard',
      },
      {
        component: CNavItem,
        name: 'Blog',
        icon: <FontAwesomeIcon icon={faList} className="nav-icon" />,
        to: '/dashboard',
      },
      {
        component: CNavItem,
        name: 'Privacy Policy',
        icon:  <FontAwesomeIcon icon={faShieldHalved} className="nav-icon" />,
        to: '/dashboard',
      },
      {
        component: CNavItem,
        name: 'Terms and Condition',
        icon:  <FontAwesomeIcon icon={faHandshake} className="nav-icon" />,
        to: '/dashboard',
      }
      
     
    ],
  },
  {
    component: CNavItem,
    name: 'Settings',
    to: '/settings',
    icon: <FontAwesomeIcon icon={faCog} className="nav-icon" />,
  },
]

export default _nav
